import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import DetailsComponent from "../../components/DetailsComponent";
import { getApi } from '../../api/endpoints.js';
import TabsComponent from '../../components/TabsComponent';
import Customer from '../../models/Customer';
import TransactionDetails from '../../components/customer_details/TransactionDetails.js';
import Challans from '../../components/customer_details/Challans.js';
import BatteryTransactionWithSwap from '../battery_transactions/CustomerBatteryTransactionListing.js';
import UserDocuments from '../document/Listing.js';

const Show = () => {
  const [customerDetails, setCustomerDetails] = useState(new Customer().toStateJson());
  const [fetchApi] = getApi('showCustomer');
  const params = useParams();
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  useEffect(() => {
    const defaultTabs = [
      {
        event: 'customer_transactions',
        heading: 'Customer Transactions',
        component: <><TransactionDetails /></>,
        ui_action: 'view_customer_transactions'
      },
      {
        event: 'customer_battery_swaps',
        heading: 'Battery Transaction and Swap Details',
        component: <BatteryTransactionWithSwap />,
        ui_action: 'view_customer_battery_swaps'
      },
      {
        event: 'customer_challans',
        heading: 'Customer Challans',
        component: <Challans />,
        ui_action: 'view_customer_challans'
      },
      {
        event: 'user_documents',
        heading: 'User Documents',
        component: <UserDocuments />,
        ui_action: 'view_user_documents'
      },
    ];

    setTabs(defaultTabs);
  }, [customerDetails])

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setCustomerDetails((new Customer(response.data.customer)).toStateJson());
    } catch (error) {
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ShowCustomerPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Customers", url: '/customers' }, { label: "Details" }]}
    className={'view-customers-details-page'}
  >
    <PageContentWrapper contentHeading={'Customer Details'}>
      <DetailsComponent data={customerDetails} />
      <TabsComponent data={tabs} defaultActiveEvent={'customer_transactions'}/>
    </PageContentWrapper>
  </Page>
};

export default Show;
